import React, { useRef } from "react";
import Webcam from "react-webcam";
import './index.css'

const WithCamera = ({children})=>{
    const webcamRef = useRef(null)
    
    return(
        <div className="container-camera">
                  <Webcam
                    audio={false}
                    mirrored
                    screenshotFormat="image/jpeg"
                    className="webcam"
                    width={1000}
                    height={600}
                    ref={webcamRef}
                  />
            {children}
        </div>
    )
}

export default WithCamera